/* Arete v2: lo script inline di _sorgente/v2.html, caricato con defer.
   Stesse funzioni, stessi selettori, stessi valori (soglie, durate, prefers-reduced-motion).
   Differenze, tutte dovute a Shopify:
   - i clic (filtri, frecce, data-vai, menu) passano da un solo listener sul documento,
     cosi' quando il Theme Editor ricarica una sezione non si duplicano i listener;
   - punti delle dosi, diario, comparse e carosello si riavviano su shopify:section:load
     solo dentro la sezione ricaricata; su shopify:section:unload si staccano gli observer. */
(() => {
  document.documentElement.classList.add('js');

  const piano = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const piste = new WeakMap(); // .pista -> {slides, meta, io, luce, contatore}

  // comparse leggere allo scorrimento
  const rv = new IntersectionObserver((es, o) => {
    for (const e of es) if (e.isIntersecting) { e.target.classList.add('in'); o.unobserve(e.target); }
  }, {threshold: .12, rootMargin: '0px 0px -40px 0px'});

  // il barattolo, contato: una slide per prodotto, si scorre col dito o con le frecce
  const vai = (pista, i) => {
    const st = piste.get(pista);
    if (!st) return;
    st.meta = Math.max(0, Math.min(st.slides.length - 1, i));
    pista.scrollTo({left: st.slides[st.meta].offsetLeft - pista.offsetLeft, behavior: piano() ? 'auto' : 'smooth'});
  };

  const ferma = pista => {
    const st = piste.get(pista);
    if (!st) return;
    st.io.disconnect();
    st.luce.disconnect();
    piste.delete(pista);
  };

  const avvia = radice => {
    // un punto per ogni dose
    for (const el of radice.querySelectorAll('.dosi[data-n]')) {
      el.innerHTML = Array.from({length: +el.dataset.n}, (_, i) => `<i style="--i:${i}"></i>`).join('');
    }
    // diario: 12 settimane x 7 giorni
    for (const el of radice.querySelectorAll('#calendario')) {
      el.innerHTML = Array.from({length: 12}, (_, w) =>
        `<span>sett. ${w + 1}</span>` + '<i></i>'.repeat(7)).join('');
    }

    radice.querySelectorAll('.rv').forEach(el => rv.observe(el));

    for (const pista of radice.querySelectorAll('.pista')) {
      ferma(pista);
      const slides = [...pista.children];
      const contatore = (pista.closest('section') || document).querySelector('#slide-n');
      const st = {slides, meta: 0};
      st.io = new IntersectionObserver(es => {
        for (const e of es) if (e.isIntersecting) {
          st.meta = slides.indexOf(e.target);
          if (contatore) contatore.textContent = st.meta + 1;
          e.target.classList.add('is-in');
        }
      }, {root: pista, threshold: .6});
      slides.forEach(s => st.io.observe(s));
      // la pista si "accende" solo quando entra nello schermo, cosi' l'animazione della prima slide si vede
      st.luce = new IntersectionObserver((es, o) => { if (es[0].isIntersecting) { pista.classList.add('vista'); o.disconnect(); } }, {threshold: .2});
      st.luce.observe(pista);
      piste.set(pista, st);
    }
  };

  document.addEventListener('click', e => {
    const t = e.target;
    if (!(t instanceof Element)) return;

    // filtri dei prodotti
    const b = t.closest('.filtri button');
    if (b) {
      const ambito = b.closest('section') || document;
      for (const x of ambito.querySelectorAll('.filtri button')) x.setAttribute('aria-pressed', x === b);
      for (const c of ambito.querySelectorAll('.carta')) c.hidden = b.dataset.filtro !== 'tutti' && c.dataset.cat !== b.dataset.filtro;
    }

    // frecce del carosello
    const passo = t.closest('[data-passo]');
    if (passo) {
      const pista = (passo.closest('section') || document).querySelector('.pista');
      const st = pista && piste.get(pista);
      if (st) vai(pista, st.meta + +passo.dataset.passo);
    }

    // tessere, carte e link del piede che aprono una slide del barattolo
    const apri = t.closest('[data-vai]');
    if (apri) {
      const pista = document.querySelector('.pista');
      if (pista) vai(pista, +apri.dataset.vai);
    }

    // menu da telefono: si chiude dopo la scelta (v2 cercava .menu a, che non esiste)
    const voce = t.closest('.sito-menu a');
    if (voce) voce.closest('details').open = false;
  });

  // Theme Editor
  document.addEventListener('shopify:section:load', e => avvia(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('.pista').forEach(ferma);
    e.target.querySelectorAll('.rv').forEach(el => rv.unobserve(el));
  });
  document.addEventListener('shopify:block:select', e => {
    const blocco = e.target;
    const comparsa = blocco.closest('.rv');
    if (comparsa) comparsa.classList.add('in');
    const slide = blocco.closest('.slide');
    const pista = slide && slide.closest('.pista');
    const st = pista && piste.get(pista);
    if (st) vai(pista, st.slides.indexOf(slide));
  });

  avvia(document);
})();
